"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Questionnaire_1 = require("../Model/Question/Questionnaire");
const Collection_1 = require("../Model/Collection");
class QuestionnaireToDataTransformer {
    constructor(questionTransformer) {
        this.questionTransformer = questionTransformer;
    }
    /**
     * @inheritDoc
     */
    to(questionnaires) {
        // Implement when needed.
        return {};
    }
    /**
     * @inheritDoc
     */
    from(data) {
        data.questions.items = data.questions.items.sort((a, b) => {
            return a.weight - b.weight;
        });
        const questions = new Collection_1.default(data.questions.items.map(item => this.questionTransformer.from(item)));
        return [new Questionnaire_1.default()
                .setId(data.id)
                .setMachineName(data.machineName)
                .setTitle(data.title)
                .setDescription(data.description)
                .setQuestions(questions)];
    }
}
exports.default = QuestionnaireToDataTransformer;
